export default defineNuxtPlugin((nuxtApp) => {
  const handleError = (err: unknown) => {
    console.error(err)
    if (import.meta.client) {
      const { $sentryCaptureException } = useNuxtApp()
      $sentryCaptureException(err)
    }
  }

  nuxtApp.hook('vue:error', handleError)
  nuxtApp.hook('app:error', handleError)
  nuxtApp.vueApp.config.errorHandler = handleError
})
